export default function textSubstringFormatter(text: string, max_length: number) {
  return text && text.length > max_length ? text.substring(0, max_length) + '...' : text
}